import React, {useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "jquery/dist/jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import { connect } from "react-redux";
import { BASE_URL } from "./config";
import socketIOClient from "socket.io-client";
import { updateRealtimeChatSuccess } from "./store/users/actions";

const App = (props) => {
  const socket = socketIOClient(BASE_URL);
  useEffect(()=>{
    let userId = localStorage.getItem("userId");
    socket.emit("join", { userId });
    socket.on("chats", (data) => {
      props.updateRealtimeChatSuccess(data);
    });
  }, [])
  return (
    <Router>
      <div className="App">
        <Routes />
      </div>
    </Router>
  );
};

export default connect(null,{
  updateRealtimeChatSuccess
})(App);
